import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LANGUAGE, languageType } from "./Constants";
import resources from "./language/resources";

export const DEFAULT_LANGUAGE = LANGUAGE.EN;

export const getCurrentLanguage = () => i18n.language;

export const getDeviceLanguage = () => {
  try {
    const language = window.navigator?.language?.slice(0, 2);
    if (Object.values(LANGUAGE).includes(language)) {
      return language;
    }
    return DEFAULT_LANGUAGE;
  } catch (e) {
    return DEFAULT_LANGUAGE;
  }
};

const getLanguageFromUrl = (): string => {
  const languageFromUrl = window.location.href.split('/').find(el => el.includes('language'))?.split('=')[1]
  return languageFromUrl || getDeviceLanguage()
}

export const changeLanguage = (language: languageType) => {
  if (language === getCurrentLanguage()) {
    return;
  }
  i18n.changeLanguage(
    Object.prototype.hasOwnProperty.call(resources, language)
      ? language
      : DEFAULT_LANGUAGE,
  );
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getLanguageFromUrl(), // if you're using a language detector, do not define the lng option
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

  export default i18n;